import { Box, styled } from "@mui/material";
import { IStyledPanelProps } from "./types";

const StyledPanel = styled(Box)<IStyledPanelProps>(({theme})=>({
    position: 'relative',
    boxSizing: "border-box",
    width: "100%"
}))

export {StyledPanel}